import React from 'react';
import PropTypes from 'prop-types';
import {Col, Collapse, Row} from "reactstrap";
import {FilterTypeComponent} from "../index";
import home from "../../../../../../util/clipstore/user/home";

FilterContainer.propTypes = {
    isContentList: PropTypes.bool.isRequired,
    pricingType: PropTypes.string.isRequired,
    setPricingType: PropTypes.func.isRequired,
    contentType: PropTypes.string.isRequired,
    setContentType: PropTypes.func.isRequired,
    sortBy: PropTypes.string.isRequired,
    setSortBy: PropTypes.func.isRequired,
};

function FilterContainer(props) {
    return (
        <Collapse isOpen={props.isContentList}>
            <Col sm="12" className="bg-white p-3 mb-3 rounded">
                <Row>
                    <Col sm="2">
                        <FilterTypeComponent
                            isCheckBox
                            filter={home.filters.content}
                            defaultFilter={props.contentType}
                            setFilter={props.setContentType}/>
                    </Col>
                    <Col sm="2">
                        <FilterTypeComponent
                            isCheckBox
                            filter={home.filters.price}
                            defaultFilter={props.pricingType}
                            setFilter={props.setPricingType}/>
                    </Col>
                    <Col sm="2">
                        <FilterTypeComponent
                            filter={home.filters.sort}
                            defaultFilter={props.sortBy}
                            setFilter={props.setSortBy}/>
                    </Col>
                </Row>
            </Col>
        </Collapse>
    );
}

export default FilterContainer;